export const Bold = ({ children, style }) => {
  return <span style={{ fontWeight: 'bold', ...style }}>{children}</span>;
};

export const Italic = ({ children, style }) => {
  return <span style={{ fontStyle: 'italic', ...style }}>{children}</span>;
};
